import { render, staticRenderFns } from "./AppStorePage.vue?vue&type=template&id=d1446910&scoped=true"
import script from "./AppStorePage.vue?vue&type=script&lang=js"
export * from "./AppStorePage.vue?vue&type=script&lang=js"
import style0 from "./AppStorePage.vue?vue&type=style&index=0&id=d1446910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1446910",
  null
  
)

export default component.exports